export default {"src":"/_next/static/media/repareo.38e626de.svg","height":35,"width":136};